export const UserTypes = {
  seeker: 'seeker',
  provider: 'provider'
};
